module.exports = __webpack_public_path__ + "static/grafika6-e573ab3de0641232fee55c5d06256e0e.png";